'use client';

import { Background, MiniMap, ReactFlow, useEdgesState, useNodesState } from '@xyflow/react';
import { _serviceEdges, _serviceNodes } from '@/data';
import { nodeTypes } from './nodes';
export const Diagram = () => {
  const [nodes, _setNodes, onNodesChange] = useNodesState(_serviceNodes);
  const [edges, _setEdges, onEdgesChange] = useEdgesState(_serviceEdges);
  return <div className='overflow-hidden rounded-lg border border-foreground/10'>
      <div className='relative h-96 w-full overflow-hidden rounded-lg'>
        <ReactFlow edges={edges} nodes={nodes} nodeTypes={nodeTypes} onEdgesChange={onEdgesChange} onNodesChange={onNodesChange} proOptions={{
        hideAttribution: true
      }}>
          <MiniMap />
          <Background />
        </ReactFlow>
      </div>
    </div>;
};